/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Gateway (meta MCP server) filter option with usage in the selected time window
 */
export type ToolUsageGatewayFilterOption = {
  /**
   * Number of tool usage events dispatched through or observed against the gateway
   */
  eventCount: number;
  /**
   * Gateway (meta MCP server) id
   */
  metaMcpServerId: string;
  /**
   * Gateway display name; a deleted gateway keeps its last name
   */
  name: string;
};

/** @internal */
export const ToolUsageGatewayFilterOption$inboundSchema: z.ZodMiniType<
  ToolUsageGatewayFilterOption,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    meta_mcp_server_id: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "meta_mcp_server_id": "metaMcpServerId",
    });
  }),
);

export function toolUsageGatewayFilterOptionFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageGatewayFilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageGatewayFilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageGatewayFilterOption' from JSON`,
  );
}
